'use client';

import type { ReactNode } from 'react';
import { cn } from '~/utils';

type ActivitySearchFiltersOverlayProps = {
    children: ReactNode;
};

/**
 * Positions the filter / AI surface stack relative to the hero.
 *
 * Mobile: flows in normal document order directly beneath the content-height hero — the hero's
 * bottom padding provides the gap, and the panel's own height pushes the results panel down, so no
 * reserved height or magic offsets are needed. In AI mode the region renders nothing (composer
 * lives in the sidebar), so this collapses to zero height.
 *
 * Desktop: an absolute single-row bar straddling the constant-height hero edge.
 */
export function ActivitySearchFiltersOverlay({ children }: ActivitySearchFiltersOverlayProps) {
    return (
        <div
            className={cn(
                'relative z-30 flex flex-col items-center gap-1.5 px-4 sm:gap-2 sm:px-6',
                'lg:absolute lg:inset-x-0 lg:top-full lg:mt-0 lg:-translate-y-[88px]',
            )}
        >
            {children}
        </div>
    );
}
